@if (applicationStateService.userData.isTeacher) {
    <div class="homework-wrapper">
        <ng-container>
            @if (isLoggedIn || isDigi4SchoolUser || bookAccessCode || applicationStateService.bookConfig.bookPermissions.quickLinks.view) {
                <div class="form-wrapper">
                    <test-generator-form
                        #form></test-generator-form>
                </div>
            }
            @if (loading) {
                <img [src]="'spinner-grey-lg.svg' | asset" alt="Wird geladen..." class="spinner"/>
            }
            @if (!homeworkService.testGeneratorOpened && !loading) {
                @if (homeworkService.tests?.length > 0) {
                    <ul class="homework-list">
                        @for (test of homeworkService.tests; track test) {
                            <li>
                                <sidebar-test-generator-item (editTest)="editTest($event)"
                                                             [test]="test"></sidebar-test-generator-item>
                            </li>
                        }
                    </ul>
                }
            }
        </ng-container>
    </div>
}
